const PHOTON = "https://photon.komoot.io";
const TOLL_EUR_KM = 0.075;
const FUEL_EUR_KM = 0.07 * 1.85;

const geocode = async (text) => {
  const r = await fetch(`${PHOTON}/api/?q=${encodeURIComponent(text)}&limit=1`);
  const f = (await r.json()).features?.[0];
  return f?.geometry?.coordinates;
};

export const estimateRoute = async (origin, destination) => {
  const [a, b] = await Promise.all([geocode(origin), geocode(destination)]);
  if (!a || !b) return null;
  const r = await fetch(`https://router.project-osrm.org/route/v1/driving/${a[0]},${a[1]};${b[0]},${b[1]}?overview=false`);
  const route = (await r.json()).routes?.[0];
  return route ? { distance_km: Math.round(route.distance / 100) / 10, duration_min: Math.round(route.duration / 60) } : null;
};

export const routeCosts = (km) => ({ toll: km >= 30 ? km * TOLL_EUR_KM : 0, fuel: km * FUEL_EUR_KM });

export const formatDuration = (min) => (min >= 60 ? `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, "0")}` : `${min} min`);
